<div class="site-map min-h-50 text-white">
    <div class="slider-bg-img gradient01 ">
        <div class="container">
            <nav class="py-4">
                <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold"><meta itemprop="position" content="1">
                    <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
                  <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item active" aria-current="page"><meta itemprop="position" content="2"><span itemprop="name">Plan du site</span></li>
                </ol>
            </nav>
            <div class="row row-cols-md-1 row-cols-sm-1 ">
                <div class="slider-txt py-md-5 py-sm-2">
                    <div class="h-100">
                        <h1 class="heading">
                            Plan du <span style="color : #BADFFF"> site
                            </span>
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container text-black py-4">
        <div class="content content-sitemap">
            <div class="row">
                <div class="col-xs-6 col-md-3">
                    <h2>Accueil</h2>
                    <ul>
                        <li [routerLinkActive]="['active']"><a [routerLink]="['/']">ACCUEIL</a></li>
                        <li [routerLinkActive]="['active']"><a [routerLink]="['/faq-the-door-man.html']">FAQ</a></li>
                        <li [routerLinkActive]="['active']"><a [routerLink]="['/contact-the-door-man.html']">CONTACT</a>
                        </li>
                    </ul>
                </div>
                <div class="col-xs-6 col-md-3">
                    <h2>Vendre un bien</h2><br>
                    <ul>
                        <li [routerLinkActive]="['active']"><a [routerLink]="['/nos-formules-the-door-man.html']">VENDRE
                                UN BIEN</a></li>
                        <li [routerLinkActive]="['active']"><a [routerLink]="['/le-concept-the-door-man.html']">QUI
                                SOMMES-NOUS ?</a></li>
                    </ul>
                </div>
                <div class="col-xs-6 col-md-3">
                    <h2>Nous recrutons</h2><br>
                    <ul>
                        <li [routerLinkActive]="['active']"><a href="https://thedoorman-recrute.fr/"
                                target="_blank">NOUS REJOINDRE</a></li>
                    </ul>
                </div>
                <div class="col-xs-6 col-md-3">
                    <h2>Divers</h2><br>
                    <ul>
                        <li [routerLinkActive]="['active']"><a [routerLink]="['/agent-immo.html']">CONSEILLER IMMO</a></li>
                        <li [routerLinkActive]="['active']"><a
                                [routerLink]="['/mentions-legales-the-door-man.html']">MENTIONS LEGALES</a></li>
                        <li [routerLinkActive]="['active']"><a [routerLink]="['/charte-protection-données.html']">CHARTE
                                DE PROTECTION DES DONNEES PERSONNELLES</a></li>
                    </ul>
                </div>
                <app-sitemap-items></app-sitemap-items>
            </div>
        </div>
    </div>
</div>
